import MenuBookIcon from "@mui/icons-material/MenuBook";
import StudentLedgerPage from "./StudentLedgerPage";

export default {
  list: StudentLedgerPage,
  icon: MenuBookIcon,
  label: "Student ledger",
  options: { label: "Student ledger" },
  name: "feeLedger",
};
